import React, { useState, useEffect } from 'react';
import { X, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import apiClient from '../utils/api';
import './RecommendationWidget.css';

function RecommendationWidget({ onActivate }) {
  const { t } = useTranslation();
  const [recommendation, setRecommendation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    loadRecommendation();
  }, []);

  const loadRecommendation = async () => {
    try {
      const rec = await apiClient.getCurrentRecommendation();
      setRecommendation(rec);
    } catch (error) {
      console.error('Error loading recommendation:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('recommendationDismissed', 'true');
  };

  const handleMarkAsRead = async () => {
    if (!recommendation?.id) return;
    
    try {
      await apiClient.dismissRecommendation(recommendation.id);
      setDismissed(true);
      // Also set in session storage to prevent reload showing it again
      sessionStorage.setItem('recommendationDismissed', 'true');
    } catch (error) {
      console.error('Error dismissing recommendation:', error);
    }
  };

  if (loading || !recommendation || dismissed) {
    return null;
  }

  return (
    <div className="recommendation-widget" style={{
      '--rec-color': recommendation.frequency_color
    }}>
      <button 
        onClick={handleDismiss} 
        className="rec-close-btn"
        data-testid="dismiss-recommendation"
        title={t('common.hide')}
      >
        <X size={20} />
      </button>
      
      <div className="rec-badge">
        {recommendation.type === 'moon_phase' ? t('recommendation.moonPhase') : t('recommendation.expertTip')}
      </div>
      
      <div className="rec-content">
        <h3 className="rec-title">{recommendation.title}</h3>
        <p className="rec-description">{recommendation.description}</p>
        
        <div className="rec-frequency">
          <span className="rec-freq-icon" style={{ color: recommendation.frequency_color }}>
            {recommendation.frequency_icon}
          </span>
          <span className="rec-freq-name">{recommendation.frequency_name}</span>
        </div>

        <div className="rec-actions-bottom">
          <button
            onClick={() => onActivate && onActivate(recommendation.frequency_id)}
            className="btn-activate-recommendation"
            style={{ borderColor: recommendation.frequency_color }}
          >
            {t('recommendation.activateFrequency')}
          </button>
          <button 
            onClick={handleMarkAsRead} 
            className="btn-dismiss-recommendation"
            data-testid="check-recommendation"
          >
            {t('recommendation.dontShowAgain')}
          </button>
        </div>
      </div>

      <div className="rec-glow" style={{ backgroundColor: recommendation.frequency_color }}></div>
    </div>
  );
}

export default RecommendationWidget;
